// extracted by mini-css-extract-plugin
module.exports = {"content":"ConfirmButton_content__3YUjS","actions":"ConfirmButton_actions__22Pao"};